export default __webpack_public_path__ + "static/Education Agent Application-fc6e3180cc90cbada92d06336cd556e5.pdf";